export default __webpack_public_path__ + "6c463095630d3ff4d9d39986a2ad630c.svg";